import React, {
    useRef,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Playhead from './Playhead';
import Trimmer from './Trimmer';

const Wrapper = styled.div`
    margin: 30px 10px;
`;

const Slider = (props) => {

    const {
        deviceInfo,
        endTime,
        getRoundedSegment,
        wasPlaying,
        isShowingTicks,
        isSliding,
        mediaPlayer,
        originalDuration,
        playhead,
        segments,
        setEndTime,
        setPlayhead,
        setStartTime,
        step,
        startTime,
    } = props;

    const isTrimming = useRef(false);

    const isIos = deviceInfo?.details?.ios;

    if(!mediaPlayer) {

        return null;

    }

    return (
        <Wrapper>
            <Playhead
                endTime={endTime}
                isIos={isIos}
                wasPlaying={wasPlaying}
                isSliding={isSliding}
                isTrimming={isTrimming}
                mediaPlayer={mediaPlayer}
                originalDuration={originalDuration}
                playhead={playhead}
                segments={segments}
                setPlayhead={setPlayhead}
                step={step}
                startTime={startTime}
            />
            <Trimmer
                endTime={endTime}
                isIos={isIos}
                getRoundedSegment={getRoundedSegment}
                wasPlaying={wasPlaying}
                isShowingTicks={isShowingTicks}
                isSliding={isSliding}
                isTrimming={isTrimming}
                mediaPlayer={mediaPlayer}
                playhead={playhead}
                segments={segments}
                setEndTime={setEndTime}
                setPlayhead={setPlayhead}
                setStartTime={setStartTime}
                step={step}
                startTime={startTime}
            />
        </Wrapper>
    );

};

Slider.propTypes = {
    endTime: PropTypes.number.isRequired,
    getRoundedSegment: PropTypes.func.isRequired,
    wasPlaying: PropTypes.bool.isRequired,
    isSliding: PropTypes.shape({
        current: PropTypes.bool.isRequired,
    }).isRequired,
    originalDuration: PropTypes.number.isRequired,
    playhead: PropTypes.number.isRequired,
    segments: PropTypes.array.isRequired,
    setEndTime: PropTypes.func.isRequired,
    setPlayhead: PropTypes.func.isRequired,
    setStartTime: PropTypes.func.isRequired,
    step: PropTypes.number.isRequired,
    startTime: PropTypes.number.isRequired,
    deviceInfo: PropTypes.object,
    isShowingTicks: PropTypes.bool,
    mediaPlayer: PropTypes.object,
};

Slider.defaultProps = {
    mediaPlayer: {},
    deviceInfo: {},
    isShowingTicks: false,
};

export default Slider;
